export default __webpack_public_path__ + "static/media/R40.88e74b69.png";